import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import styles from './WhatsAppPhonePreview.module.css';

// Negrito (*texto*) e itálico (_texto_) do WhatsApp, sem HTML
const FORMAT = /(\*[^*\n]+\*|_[^_\n]+_)/g;

function formatLine(line, lineIndex) {
  return line.split(FORMAT).map((part, index) => {
    const key = `${lineIndex}-${index}`;
    if (part.length > 2 && part.startsWith('*') && part.endsWith('*')) return <strong key={key}>{part.slice(1, -1)}</strong>;
    if (part.length > 2 && part.startsWith('_') && part.endsWith('_')) return <em key={key}>{part.slice(1, -1)}</em>;
    return part;
  });
}

function MessageText({ text }) {
  const lines = String(text || '').split('\n');
  return lines.map((line, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={index}>
      {formatLine(line, index)}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ));
}

const nowLabel = () => new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

/**
 * Celular desenhado com a conversa do WhatsApp do teste da configuração inicial:
 * o texto e os botões vêm prontos do backend (SetupDemo::preview), iguais ao que é enviado.
 * typing: a mensagem ainda está saindo. answer: 'confirmed' | 'canceled' depois do toque.
 * pointConfirm: esperando a resposta, o primeiro botão ("Confirmar presença") pulsa.
 * No celular o aparelho some e fica só a conversa.
 */
function WhatsAppPhonePreview({ preview, typing = false, answer = null, pointConfirm = false }) {
  const initial = (preview.sender || 'G').trim().charAt(0).toUpperCase();

  return (
    <div className={styles.phone}>
      {answer === 'confirmed' && (
        <span className={styles.seal}><CheckCircleIcon fontSize="inherit" /> Confirmado</span>
      )}
      <div className={styles.screen}>
        <div className={styles.chatHeader}>
          <span className={styles.avatar}>{initial}</span>
          <span className={styles.contact}>
            <strong>{preview.sender}</strong>
            <small>{typing ? 'digitando...' : 'online'}</small>
          </span>
        </div>

        <div className={styles.chat}>
          <span className={styles.dayChip}>Hoje</span>

          {typing ? (
            <div className={`${styles.bubble} ${styles.typing}`} aria-label="Enviando a mensagem">
              <span /><span /><span />
            </div>
          ) : (
            <div className={styles.message}>
              <div className={styles.bubble}>
                <p className={styles.text}><MessageText text={preview.message} /></p>
                <span className={styles.time}>{nowLabel()}</span>
              </div>
              {(preview.buttons || []).map((label, index) => (
                <div
                  key={label}
                  className={`${styles.button} ${pointConfirm && index === 0 ? styles.buttonPoint : ''}`}
                >
                  <OpenInNewIcon fontSize="inherit" />
                  {label}
                </div>
              ))}
            </div>
          )}

          {answer === 'confirmed' && (
            <span className={`${styles.systemChip} ${styles.systemDone}`}>
              <CheckCircleIcon fontSize="inherit" /> Presença confirmada pelo botão
            </span>
          )}
          {answer === 'canceled' && (
            <span className={styles.systemChip}>Você respondeu que não vai</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default WhatsAppPhonePreview;
